<template>
	<div id="wrapper" :class="langCss">
		<!-- start header -->
		<header>
			<div class="navbar navbar-default navbar-static-top">
				<div class="container">
					<div class="navbar-header">
						<button type="button" class="navbar-toggle" data-toggle="collapse"
							data-target=".navbar-collapse">
							<span class="icon-bar"></span>
							<span class="icon-bar"></span>
							<span class="icon-bar"></span>
						</button>
						<a class="navbar-brand" href="index.html"><img src="/static/img/logo.png" alt="logo" /></a>
					</div>
					<div class="navbar-collapse collapse ">
						<ul class="nav navbar-nav">
							<li><router-link to="/" class="navbar-item">{{ $t('message.home') }}</router-link></li>
                            <li><router-link to="/services" class="navbar-item">{{ $t('message.serve') }}</router-link></li>
							<!-- <li v-if="langCss != 'cn'"><a href="http://www.cflytrip.com" class="navbar-item" style="color:coral" >{{ $t('message.book') }}</a></li> -->
                            <li><router-link to="/portf" class="navbar-item">{{ $t('message.port') }}</router-link></li>
                            <li class="active"><router-link to="/aboutus" class="navbar-item">{{ $t('message.au') }}</router-link></li>
                            <li><router-link to="/pricing" class="navbar-item">{{ $t('message.pric') }}</router-link></li>
                            <li><router-link to="/contact" class="navbar-item">{{ $t('message.contact') }}</router-link></li>
                        </ul>
                    </div>
                    <!-- <div class="sigenin"><a style="text-decoration: none;color: inherit;" href="http://ht.piaomou.com" target="_blank">{{ $t('message.signIn') }}</a></div> -->
					<div class="ceswich">
                        <button style="background:none;border:none" :class="langCss === 'cn' ? 'xz' : ''" @click="switchLang('cn')">{{ $t('message.switchCn') }}</button> |
                        <button style="background:none;border:none" :class="langCss === 'en' ? 'xz' : ''" @click="switchLang('en')">{{ $t('message.switchEn') }}</button>
                    </div>
				</div>
			</div>
		</header>
		<section id="inner-headline">
			<div class="container">
				<div class="row">
					<div class="col-lg-12">
						<h2 class="pageTitle">{{ $t('message.au') }}</h2>
					</div>
				</div>
			</div>
		</section>
		<section id="content">
			<div class="container">

				<div class="about">

					<div class="row">
						<div class="col-md-12">
							<div class="about-logo">
								<h3>{{ $t('message.auTit') }}<span class="color"></span></h3>
								<p> {{ $t('message.auCon') }}</p>
								<p> {{ $t('message.auCon2') }}</p>
							</div>
						</div>
					</div>

					<hr>
					<br>

					<div class="row">
						<div class="col-md-4">
							<!-- Heading and para -->
							<div class="block-heading-two">
								<h3><span>{{ $t('message.auChoose') }}</span></h3>
							</div>
							<p>{{ $t('message.auChooseCon') }}</p>
						</div>
						<div class="col-md-4">
							<div class="block-heading-two">
								<h3><span>{{ $t('message.auOur') }}</span></h3>
							</div>
							<!-- Accordion starts -->
							<div class="panel-group" id="accordion-alt3">
								<!-- Panel. Use "panel-XXX" class for different colors. Replace "XXX" with color. -->
								<div class="panel">
									<!-- Panel heading -->
									<div class="panel-heading">
										<h4 class="panel-title">
											<a data-toggle="collapse" data-parent="#accordion-alt3"
												href="#collapseOne-alt3">
												<i class="fa fa-angle-right"></i> {{ $t('message.productsTit') }}
											</a>
										</h4>
									</div>
									<div id="collapseOne-alt3" class="panel-collapse collapse">
										<!-- Panel body -->
										<div class="panel-body">{{ $t('message.productsCon') }}</div>
									</div>
								</div>
								<div class="panel">
									<div class="panel-heading">
										<h4 class="panel-title">
											<a data-toggle="collapse" data-parent="#accordion-alt3"
												href="#collapseTwo-alt3">
												<i class="fa fa-angle-right"></i>  {{ $t('message.productsTit2') }}
											</a>
										</h4>
									</div>
									<div id="collapseTwo-alt3" class="panel-collapse collapse">
										<div class="panel-body">{{ $t('message.productsCon2') }}</div>
									</div>
								</div>
								<div class="panel">
									<div class="panel-heading">
										<h4 class="panel-title">
											<a data-toggle="collapse" data-parent="#accordion-alt3"
												href="#collapseThree-alt3">
												<i class="fa fa-angle-right"></i> {{ $t('message.productsTit3') }}
											</a>
										</h4>
									</div>
									<div id="collapseThree-alt3" class="panel-collapse collapse">
										<div class="panel-body">{{ $t('message.productsCon3') }}</div>
									</div>
								</div>
								<!-- <div class="panel">
									<div class="panel-heading">
										<h4 class="panel-title">
											<a data-toggle="collapse" data-parent="#accordion-alt3"
												href="#collapseFour-alt3">
												<i class="fa fa-angle-right"></i> Accordion Heading Text Item # 4
											</a>
										</h4>
									</div>
									<div id="collapseFour-alt3" class="panel-collapse collapse">
										<div class="panel-body">
											Sed ut perspiciaatis unde omnis iste natus error sit voluptatem accusantium
											doloremque
											laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis
											et quasi architecto
											beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas
										</div>
									</div>
								</div> -->
							</div>
							<!-- Accordion ends -->

						</div>

						<div class="col-md-4">
							<div class="block-heading-two">
								<h3><span> {{ $t('message.Expertise') }}</span></h3>
							</div>
							<h6>{{$t('message.ExpertiseTit')}}</h6>
							<div class="progress pb-sm">
								<!-- White color (progress-bar-white) -->
								<div class="progress-bar progress-bar-red" role="progressbar" aria-valuenow="40"
									aria-valuemin="0" aria-valuemax="100" style="width: 40%">
									<span class="sr-only">{{ $t('message.ExpertiseCon') }}</span>
								</div>
							</div>
							<h6>{{$t('message.ExpertiseTit2')}}</h6>
							<div class="progress pb-sm">
								<div class="progress-bar progress-bar-green" role="progressbar" aria-valuenow="60"
									aria-valuemin="0" aria-valuemax="100" style="width: 60%">
									<span class="sr-only">{{ $t('message.ExpertiseCon2') }}</span>
								</div>
							</div>
							<h6>{{$t('message.ExpertiseTit3')}}</h6>
							<div class="progress pb-sm">
								<div class="progress-bar progress-bar-lblue" role="progressbar" aria-valuenow="80"
									aria-valuemin="0" aria-valuemax="100" style="width: 80%">
									<span class="sr-only">{{ $t('message.ExpertiseCon3') }}</span>
								</div>
							</div>
							<h6>{{$t('message.ExpertiseTit4')}}</h6>
							<div class="progress pb-sm">
								<div class="progress-bar progress-bar-yellow" role="progressbar" aria-valuenow="30"
									aria-valuemin="0" aria-valuemax="100" style="width: 30%">
									<span class="sr-only">{{ $t('message.ExpertiseCon4') }}</span>
								</div>
							</div>
						</div>
					</div>
					<br>
					<!-- Our Team starts -->

					<!-- Heading -->
					<div class="block-heading-six">
						<h4 class="bg-color">{{ $t('message.TeamCore') }}</h4>
					</div>
					<br>
					<!-- Our team starts -->

					<div class="team-six">
						<div class="row">
							<div class="col-md-3 col-sm-6">
								<!-- Team Member -->
								<div class="team-member">
									<!-- Image -->
									<img class="img-responsive" src="/static/img/team1.jpg" alt="">
									<!-- Name -->
									<h4>Johne Doe</h4>
									<span class="deg">Creative</span>
								</div>
							</div>
							<div class="col-md-3 col-sm-6">
								<!-- Team Member -->
								<div class="team-member">
									<!-- Image -->
									<img class="img-responsive" src="/static/img/team2.jpg" alt="">
									<!-- Name -->
									<h4>Jennifer</h4>
									<span class="deg">Programmer</span>
								</div>
							</div>
							<div class="col-md-3 col-sm-6">
								<!-- Team Member -->
								<div class="team-member">
									<!-- Image -->
									<img class="img-responsive" src="/static/img/team3.jpg" alt="">
									<!-- Name -->
									<h4>Christean</h4>
									<span class="deg">CEO</span>
								</div>
							</div>
							<div class="col-md-3 col-sm-6">
								<!-- Team Member -->
								<div class="team-member">
									<!-- Image -->
									<img class="img-responsive" src="/static/img/team4.jpg" alt="">
									<!-- Name -->
									<h4>Kerinele rase</h4>
									<span class="deg">Manager</span>
								</div>
							</div>
						</div>
					</div>
					<!-- Our team ends -->
				</div>
			</div>
		</section>

		<footer>
                <div class="container">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="widget">
                                <address style="width:60%;float: left;">
                                    <strong>{{$t('message.addr')}}</strong><br>
                                    {{$t('message.addrcon')}}
                                </address>
                                <p style="margin-left:5%;width:30%;float: left;">
                                    <strong>{{$t('message.widgetCn')}}</strong><br>
                                    <i class="icon-phone"></i> {{$t('message.fixedTelephone')}} <br>
                                    <i class="icon-envelope-alt"></i> leo@cflytrip.com
                                </p>
                            </div>
                        </div>
                        <!-- <div class="col-lg-3">
                            <div class="widget">
                                <h5 class="widgetheading"> {{$t('message.domestic')}} </h5>
                                <ul class="link-list">
                                    <li><a href="https://www.csair.com" target="_blank">{{$t('message.flinkCon')}}</a></li>
                                    <li><a href="https://www.xiamenair.com" target="_blank">{{$t('message.flinkCon2')}}</a></li>
                                    <li><a href="https://www.sda.cn" target="_blank">{{$t('message.flinkCon3')}}</a></li>
                                    <li><a href="https://www.juneyaoair.com" target="_blank">{{$t('message.flinkCon4')}}</a></li>
                                    <li><a href="https://www.cdal.com.cn" target="_blank">{{$t('message.flinkCon5')}}</a></li>
                                    <li><a href="https://www.loongair.cn" target="_blank">{{$t('message.flinkCon6')}}</a></li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-lg-3">
                            <div class="widget">
                                <h5 class="widgetheading">{{$t('message.international')}}</h5>
                                <ul class="link-list">
                                    <li><a href="https://www.vietjet-air.com/" target="_blank">{{$t('message.flinkCon7')}}</a></li>
                                    <li><a href="https://www.koreanair.com/" target="_blank">{{$t('message.flinkCon8')}}</a></li>
                                    <li><a href="https://www.ana.co.jp/" target="_blank">{{$t('message.flinkCon9')}}</a></li>
                                    <li><a href="https://www.hkexpress.com/" target="_blank">{{$t('message.flinkCon10')}}</a></li>
                                    <li><a href="https://www.flyasiana.com/" target="_blank">{{$t('message.flinkCon11')}}</a></li>
                                    <li><a href="https://www.united.com/" target="_blank">{{$t('message.flinkCon12')}}</a></li>
                                </ul>
                            </div>
                        </div> -->
                        <!-- <div class="col-lg-3">
                            <div class="widget">
                                <h5 class="widgetheading">{{$t('message.platform')}}</h5>
                                <ul class="link-list">
                                    <li><a href="https://www.ctrip.com/" target="_blank">{{$t('message.flinkCon13')}}</a></li>
                                    <li><a href="https://www.qunar.com/" target="_blank">{{$t('message.flinkCon14')}}</a></li>
                                    <li><a href="https://www.ly.com/" target="_blank">{{$t('message.flinkCon15')}}</a></li>
                                    <li><a href="https://www.fliggy.com/" target="_blank">{{$t('message.flinkCon16')}}</a></li>
                                    <li><a href="https://www.meituan.com/" target="_blank">{{$t('message.flinkCon17')}}</a></li>
                                    <li><a href="https://buyer.pkfare.com/" target="_blank">{{$t('message.flinkCon18')}}</a></li>
                                </ul>
                            </div>
                        </div> -->
                    </div>
                </div>
                <div id="sub-footer">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-6">
                                <div class="copyright">
                                    <p>
                                        <a href="https://beian.miit.gov.cn/" target="_blank">ICP备2020020380号-1</a>
                                        <span>&copy; Copyright 2001 - 2025 feixing001.com All Rights Reserved. </span>
                                    </p>
                                </div>
                            </div>
                            <div class="col-lg-6" style="position: relative;">
                              <a class="rztz" href="http://cx.cnca.cn/CertECloud/result/skipResultList?certNumber=05324I10341R0M%20%20%20&orgName=&fromIndex=true" target="_blank"><img class="ISO2007RZ" src="/static/img/rz2007.png" alt=""></a>
                                <!-- <ul class="social-network">
                                    <li>
                                        <a href="#" data-placement="top" title="Facebook"><i class="fa fa-facebook"></i></a>
                                    </li>
                                    <li>
                                        <a href="#" data-placement="top" title="Twitter"><i class="fa fa-twitter"></i></a>
                                    </li>
                                    <li>
                                        <a href="#" data-placement="top" title="Linkedin"><i class="fa fa-linkedin"></i></a>
                                    </li>
                                    <li>
                                        <a href="#" data-placement="top" title="Pinterest"><i class="fa fa-pinterest"></i></a>
                                    </li>
                                    <li>
                                        <a href="#" data-placement="top" title="Google plus"><i class="fa fa-google-plus"></i></a>
                                    </li>
                                </ul> -->
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
	</div>
</template>
<style scoped>
.vue-css button {
    width: 150px;
}

.en .vue-css button {
    color: steelblue;
}

.cn .vue-css button {
    color: #666;
}

.ja .vue-css button {
    color: seagreen;
}

.xz {
    color: #37A691
}
</style>
<script>
// import { mapGetters } from 'vuex'
// import { i18n } from '/components/i18n'

export default {
	name: 'about',
	data() {
		return {
			langCss: window.localStorage.getItem("lang"),
			dialogVisible: false
		};
	},
	methods: {
		switchLang(lang) {
			this.$i18n.locale = lang;
			//把语言保存在localStorage中
			localStorage.setItem("lang", lang);
			//切换父级class
			this.langCss = lang;
		},
		handleClose(done) {
			this.$confirm(this.$t("message.confirm")) //js内部切换
				.then(_ => {
					done();
				})
				.catch(_ => { });
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/views/aboutus/aboutus.vue